import { render, staticRenderFns } from "./LegacyTabsComponent.vue?vue&type=template&id=1d02d9cd&"
import script from "./LegacyTabsComponent.vue?vue&type=script&lang=ts&"
export * from "./LegacyTabsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d02d9cd')) {
      api.createRecord('1d02d9cd', component.options)
    } else {
      api.reload('1d02d9cd', component.options)
    }
    module.hot.accept("./LegacyTabsComponent.vue?vue&type=template&id=1d02d9cd&", function () {
      api.rerender('1d02d9cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/models/Table/Legacy/LegacyTabsComponent.vue"
export default component.exports